import React from "react";
import { Button } from "@material-ui/core";
import { AppFilterChipProps } from "./app-filter-chip.types";
import { clsx } from "@mantine/core";

const AppFilterChipComponent: React.FC<AppFilterChipProps> = ({
  label,
  selected,
  size = "medium",
  color = "primary",
  onClick,
}) => {
  return (
    <Button
      onClick={onClick}
      size={size}
      style={{ borderRadius: "6px" }}
      color={selected ? color : "secondary"}
      className={clsx("app-filter-chip", { selected })}
      variant={selected ? "contained" : "outlined"}
    >
      {label}
    </Button>
  );
};

export default AppFilterChipComponent;
